<div class="modal" [ngClass]="{ 'open': isOpen }">
  <div class="modal-container">
    <h2 class="modal-title">{{'lista_compras_titulo' | transloco}}
      <button type="button" class="close" aria-label="Fechar" (click)="closeModal()">
        <span aria-hidden="true">×</span>
      </button>
    </h2>
    <div class="dialog-content">
      <p class="instrucao">{{'lista_compras_instrucao' | transloco}}</p>

      <p-fileupload mode="basic" name="file" [multiple]="false" accept=".xlsx,.xls,.csv,.pdf"
        chooseLabel="{{'lista_compras_selecionar_arquivo' | transloco}}" [auto]="false"
        (onSelect)="onFileSelected($event)">
      </p-fileupload>

      <p class="formatos-aceitos">{{'lista_compras_formatos_aceitos' | transloco}}</p>

      <div *ngIf="selectedFile" class="arquivo-selecionado">
        <span class="fas fa-file"></span>
        <span class="nome-arquivo">{{ selectedFile.name }}</span>
        <button type="button" class="remover-arquivo" (click)="removerArquivo()" aria-label="Remover arquivo">×</button>
      </div>

      <div *ngIf="error" class="error">{{ error | transloco }}</div>
    </div>
    <div class="dialog-actions">
      <button type="button" mat-button (click)="closeModal()">{{ 'cancelar' | transloco }}</button>
      <button type="button" mat-raised-button color="primary" (click)="enviarLista()"
        [disabled]="!selectedFile || enviando">
        {{'lista_compras_enviar' | transloco}}
      </button>
    </div>
  </div>
</div>
